(function () {
  // Renders the "campo obligatorio" message on the hearaboutus form-group.
  //
  // Pristine's built-in `required` doesn't reliably surface an inline error
  // for <select multiple> after Choices.js wraps it, so we do it ourselves.
  // Importantly, the error <div> does NOT carry the `pristine-error` class —
  // if it did, Pristine would treat it as its own and clear it whenever it
  // re-validated any field in the form (e.g. the live listener firing on the
  // date picker after picking a date/hour would hide our message).
  window.validateHearaboutus = function (form) {
    if (!form) return true;
    var sel = form.querySelector('select[name="hearaboutus"]');
    if (!sel) return true;
    var fg = sel.closest('.form-group');
    if (!fg) return true;

    var existing = fg.querySelector('.hearaboutus-required-error');
    if (sel.selectedOptions.length > 0) {
      if (existing) existing.remove();
      fg.classList.remove('has-danger');
      return true;
    }

    var msg = sel.getAttribute('data-pristine-required-message') || 'campo obligatorio';
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'hearaboutus-required-error text-help';
      existing.style.fontSize = '14px';
      existing.setAttribute('role', 'alert');
      fg.appendChild(existing);
    }
    existing.textContent = msg;
    fg.classList.add('has-danger');
    return false;
  };

  function initChoices() {
    if (typeof Choices === 'undefined') return;

    document.querySelectorAll('select[name="hearaboutus"]').forEach(function (el) {
      if (el.dataset.choicesInitialized === '1') return;
      el.dataset.choicesInitialized = '1';

      // Snapshot accessibility/message attributes that Choices.js may strip.
      // We do NOT re-attach `required`: Pristine would then register its
      // built-in required validator and emit a duplicate (and racy) error
      // for the same form-group. validateHearaboutus is the single source
      // of truth for hearaboutus required-state.
      var ariaRequired = el.getAttribute('aria-required');
      var requiredMsg = el.getAttribute('data-pristine-required-message');

      new Choices(el, {
        removeItemButton: true,
        shouldSort: false,
        searchEnabled: false,
        placeholder: false,
        itemSelectText: '',
        noChoicesText: ''
      });

      if (ariaRequired) el.setAttribute('aria-required', ariaRequired);
      if (requiredMsg) el.setAttribute('data-pristine-required-message', requiredMsg);

      // Mark the wrapper so CSS can pin the floating <label> in its "filled" state.
      var wrapper = el.closest('.selecthearaboutus');
      if (wrapper) wrapper.classList.add('selecthearaboutus--choices-active');

      // Clear our inline error as soon as the user picks an option.
      el.addEventListener('change', function () {
        var form = el.closest('form');
        if (form) window.validateHearaboutus(form);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChoices);
  } else {
    initChoices();
  }

  // Safety net for forms whose submit handler doesn't call validateHearaboutus
  // (e.g. #form-novios, or any form-* whose handler returns early before the
  // explicit call). Capture-phase, only blocks browser-default submission —
  // does NOT stop propagation, so the form's own submit handler still runs
  // and can validate the rest of the fields.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var sel = form.querySelector('select[name="hearaboutus"]');
    if (!sel) return;
    if (!window.validateHearaboutus(form)) {
      e.preventDefault();
    }
  }, true);
})();
